import { info_tab, preview_tab } from '../../../../../../views/contract/template';

export default {
  title: 'Șablon contract',
  tabs: {
    [info_tab]: 'Info',
    [preview_tab]: 'Previzualizare',
  },
  sections: {
    subscription: 'Abonament',
    setup_cost: 'Cost configurare',
    preview: 'Previzualizare',
  },
  form: {
    has_trial: {
      label: 'Adaugă zile de probă',
    },
    trial_days: {
      label: 'Zile de probă gratuite',
      placeholder: '7',
      validation: {
        required: 'Zilele de probă sunt obligatorii',
        min: '{{value}} este valoarea minimă pentru zilele de probă',
      },
    },
  },
  buttons: {
    apply: 'Aplică modificările',
    download: 'Descarcă',
    apply_changes: 'Aplică modificările',
  },
  files: {
    contract: '{{provider}}-contract-template-{{company}}.pdf',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea previzualizării',
  },
};
